export default {
      id: "arrow-usage",
      viewBox: "0 0 18 18",
      url: "/" + "img/marilyn-ui.svg#arrow",
      toString: function () {
        return this.url;
      }
    }